var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { GraphicEngine } from 'hanako-ts/dist-legacy/GraphicEngine';
import { computeIntersections } from './BezierIntersect';
import { eyesPortrait, eyesLandscape } from './Data';
export class AnimatedLogo extends Component {
    constructor() {
        super('AnimatedLogo', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.canvas = $('.animated-logo canvas');
            if (this.canvas.length > 0) {
                const animation = new LogoAnimation('.animated-logo canvas', { width: this.canvas.width() * 2, height: this.canvas.height() * 2, alpha: true });
                $('body').on('mousemove', (e) => {
                    AnimatedLogo.mousePosition = { x: e.clientX, y: e.clientY };
                });
                $('body').on('touchmove', (e) => {
                    AnimatedLogo.mousePosition = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                });
                $(window).on('resize', () => {
                    this.computeRatio();
                    animation.resize({ width: this.canvas.width() * 2, height: this.canvas.height() * 2 });
                });
                this.computeRatio();
            }
            this.success();
        });
    }
    computeRatio() {
        const width = this.canvas.width();
        const height = this.canvas.height();
        AnimatedLogo.ratio = width / height;
    }
}
AnimatedLogo.mousePosition = { x: 0, y: 0 };
AnimatedLogo.ratio = 1;
class LogoAnimation extends GraphicEngine {
    constructor(selector, options) {
        super(selector, options);
        this.context = this.get(0).getContext('2d', {
            alpha: this.options.alpha
        });
        if (this.length == 0)
            return;
    }
    draw() {
        this.drawEyes(AnimatedLogo.ratio > 1 ? eyesLandscape : eyesPortrait);
    }
    clear() {
        this.context.clearRect(0, 0, this.options.width, this.options.height);
    }
    drawLine(line) {
        this.context.beginPath();
        this.context.moveTo(line.p1.x, line.p1.y);
        this.context.lineTo(line.p2.x, line.p2.y);
        this.context.stroke();
    }
    drawDot(point, radius = 5) {
        this.context.beginPath();
        this.context.arc(point.x, point.y, radius, 0, 2 * Math.PI);
        this.context.fill();
    }
    drawCurve(curve) {
        this.context.beginPath();
        this.context.moveTo(curve.p1.x, curve.p1.y);
        this.context.bezierCurveTo(curve.cp1.x, curve.cp1.y, curve.cp2.x, curve.cp2.y, curve.p2.x, curve.p2.y);
        this.context.stroke();
    }
    drawEyes(eyes) {
        eyes.forEach((eye, index) => {
            /*this.context.fillStyle = '#ff0000';
            this.context.strokeStyle = '#ff0000';*/
            const mouseLine = {
                p1: eye.center,
                p2: { x: eye.center.x + this.getMouseVector(eye.center).x * 1200, y: eye.center.y + this.getMouseVector(eye.center).y * 1200 }
            };
            const intersections = [];
            eye.curves.forEach(curve => {
                intersections.push(...computeIntersections(curve, mouseLine));
                //this.drawCurve(curve);
            });
            /*this.drawLine(mouseLine);
            this.drawDot(eye.center);*/
            this.context.fillStyle = '#000';
            const eyeSize = AnimatedLogo.ratio > 1 ? 30 : 20;
            if (intersections.length > 0) {
                this.drawDot(intersections[0], eyeSize);
            }
            else {
                const lineIntersection = this.intersectLines(eye.line, mouseLine);
                this.drawDot(lineIntersection, eyeSize);
            }
        });
    }
    getMouseVector(center) {
        const centerInViewport = { x: center.x / 2 + $('.animated-logo canvas').viewportPosition().x, y: center.y / 2 + $('.animated-logo canvas').viewportPosition().y };
        const vector = { x: AnimatedLogo.mousePosition.x - centerInViewport.x, y: AnimatedLogo.mousePosition.y - centerInViewport.y };
        const length = Math.sqrt(Math.pow(vector.x, 2) + Math.pow(vector.y, 2));
        vector.x /= length;
        vector.y /= length;
        return vector;
    }
    intersectLines(line1, line2) {
        const x1 = line1.p1.x;
        const y1 = line1.p1.y;
        const x2 = line1.p2.x;
        const y2 = line1.p2.y;
        const x3 = line2.p1.x;
        const y3 = line2.p1.y;
        const x4 = line2.p2.x;
        const y4 = line2.p2.y;
        const d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (d == 0)
            return null;
        const xi = ((x3 - x4) * (x1 * y2 - y1 * x2) - (x1 - x2) * (x3 * y4 - y3 * x4)) / d;
        const yi = ((y3 - y4) * (x1 * y2 - y1 * x2) - (y1 - y2) * (x3 * y4 - y3 * x4)) / d;
        return { x: xi, y: yi };
    }
}
